function Title(props) {
  document.title = props.name + ' - PST Square';
}

export default Title;